export default {
	//基础配置-店铺权限-新增-编辑
	summarySupplement: {
		url: '/ec-pc-api/householdAppliances/manage/storeUser/saveOrUpdate',
		type: 'post'
	},
	//基础配置-店铺权限-删除
	storeUserDel: {
		url: '/ec-pc-api/householdAppliances/manage/storeUser/del',
		type: 'get'
	},
	//基础配置-提报店铺-编辑
	reportUpdate: {
		url: '/ec-pc-api/householdAppliances/manage/store/report/update',
		type: 'post'
	},
	//店铺年度各月提报状态列表
	reportStatusList: {
		url: '/ec-pc-api/householdAppliances/manage/store/reportStatusList',
		type: 'post'
	},
	//店铺可提报开关状态获取
	switchGet: {
		url: '/ec-pc-api/householdAppliances/manage/reportAble/switch/get',
		type: 'get'
	},
	//全平台-修改日志
	adjustLogSearch: {
		url: '/ec-pc-api/householdAppliances/manage/product/adjustLog/search',
		type: 'post'
	},
	//全平台-修改日志-一键已读
	adjustLogOneKeyRead: {
		url: '/ec-pc-api/householdAppliances/manage/adjustLog/oneKeyRead',
		type: 'get'
	},
	//全平台权限人员调整店铺可提报开关
	switchModify: {
		url: '/ec-pc-api/householdAppliances/manage/reportAble/switch/modify',
		type: 'get'
	},
	//全平台-产品-新增
	productAdd: {
		url: '/ec-pc-api/householdAppliances/manage/allPlat/product/add',
		type: 'post'
	},
	//全平台-产品-编辑
	productUpdate: {
		url: '/ec-pc-api/householdAppliances/manage/allPlat/product/update',
		type: 'post'
	},
	//全平台-产品-删除
	productUpDel: {
		url: '/ec-pc-api/householdAppliances/manage/allPlat/product/del',
		type: 'post'
	},
	//查询店铺某月提报状态
	storeReportStatus: {
		url: '/ec-pc-api/householdAppliances/manage/storeReportStatus',
		type: 'get'
	},
	//全平台查询店铺某月提报状态汇总
	storeReportStatusSum: {
		url: '/ec-pc-api/householdAppliances/manage/storeReportStatusSum',
		type: 'get'
	},
	//提报后产品-各店数据弹窗信息
	currentProductSaleInfo: {
		url: '/ec-pc-api/householdAppliances/manage/currentProduct/saleInfo',
		type: 'post'
	},
	//店铺(提交)
	submitProductInfo: {
		url: '/ec-pc-api/householdAppliances/manage/submitProductInfo',
		type: 'post'
	},
	//全平台提报前分页
	allPlatProductSearch: {
		url: '/ec-pc-api/householdAppliances/manage/allPlat/product/search',
		type: 'post'
	},
	//用户店铺权限下拉列表受时间控制
	userStoreList: {
		url: '/ec-pc-api/householdAppliances/manage/userStoreList',
		type: 'get'
	},
	//店铺提报前分页
	storeProductSearch: {
		url: '/ec-pc-api/householdAppliances/manage/store/product/search',
		type: 'post'
	},
	//店铺提报前提报量编辑
	updateReportNum: {
		url: '/ec-pc-api/householdAppliances/manage/store/product/updateReportNum',
		type: 'post'
	},
	//店铺-无需求操作接口
	storeNoDemand: {
		url: '/ec-pc-api/householdAppliances/manage/store/noDemand',
		type: 'post'
	},
	//店铺提报前-导入历史查询
	importHistory: {
		url: '/ec-pc-api/customize/import/history',
		type: 'post'
	},
	//店铺提报前-导入店铺产品信息
	storeProductInfo: {
		url: '/ec-pc-api/customize/import/householdAppliances/store/productInfo',
		type: 'post'
	},
	//全平台产品动态分页[提报前]-导出
	beforeAllPlatExport: {
		url: '/ec-pc-api/householdAppliances/manage/allPlat/product/export',
		type: 'post'
	},
	//店铺产品动态分页[提报前]-导出
	beforteStoreExport: {
		url: '/ec-pc-api/householdAppliances/manage/store/product/export',
		type: 'post'
	},
	//全平台产品动态分页[提报后]-导出
	afterAllPlatExport: {
		url: '/ec-pc-api/householdAppliances/manage/allPlat/product/submited/export',
		type: 'post'
	},
	//店铺产品动态分页[提报后]-导出
	afterStoreExport: {
		url: '/ec-pc-api/householdAppliances/manage/store/product/submited/export',
		type: 'post'
	},
	//全平台产品动态分页[提报后]
	afterAllPlatSearch: {
		url: '/ec-pc-api/householdAppliances/manage/allPlat/product/submited/search',
		type: 'post'
	},
	//店铺产品动态分页[提报后]
	afterStoreSearch: {
		url: '/ec-pc-api/householdAppliances/manage/store/product/submited/search',
		type: 'post'
	},
	//店铺-产品-仍需数量编辑
	updateStillNeedNum: {
		url: '/ec-pc-api/householdAppliances/manage/store/product/updateStillNeedNum',
		type: 'post'
	},
	//产品调整日志分页-弹窗
	adjustLogDialogSearch: {
		url: '/ec-pc-api/householdAppliances/manage/currentProduct/adjustLog/search',
		type: 'post'
	},
	//小件跟进-编辑
	operationUpdate: {
		url: '/ec-pc-api/householdAppliances/manage/operation/update',
		type: 'post'
	},
	//小件跟进-下架
	operationShelfRemove: {
		url: '/ec-pc-api/householdAppliances/manage/operation/shelfRemove',
		type: 'post'
	},
	//小件跟进-停销
	operationStopSale: {
		url: '/ec-pc-api/householdAppliances/manage/operation/stopSale',
		type: 'post'
	},
	//配置A类价比例
	checkConfigRatio: {
		url: '/ec-pc-api/order/check/configRatio',
		type: 'post'
	},
	//批量通过操作
	checkPass: {
		url: '/ec-pc-api/order/check/pass',
		type: 'post'
	},
	//查询A类价比例配置
	configRatioGet: {
		url: '/ec-pc-api/order/check/configRatio/get',
		type: 'post'
	},
	//查询A类价比例配置
	configRatioUpdate: {
		url: '/ec-pc-api/order/check/configRatio/update',
		type: 'post'
	},
	//导出京东厂送产品销量信息
	jdProductExport: {
		url: '/ec-pc-api/product/sales/jd/product/export',
		type: 'post'
	},
	//全平台产品动态分页[提报前]-导出-v2
	allPlatProductExport: {
		url: '/ec-pc-api/householdAppliances/manage/allPlat/product/export/v2',
		type: 'post'
	},
}